/**
 * Track constants shared between admin and student courses UI.
 *
 * Tracks are hard-coded (not stored). The slug values must match the backend
 * literal type in models/course.py.
 */
export const TRACKS = [
  { slug: "tronc-commun", labelKey: "courses.track_tronc_commun" },
  { slug: "modules-complementaires", labelKey: "courses.track_modules" },
];

export const getTrackLabel = (slug, t) => {
  const tr = TRACKS.find((x) => x.slug === slug);
  return tr ? t(tr.labelKey) : slug;
};
